const typeOptions = [
	{ key: 1, text: "Detallado", value: "Detallado" },
	{ key: 2, text: "Resumido", value: "Resumido" },
	{ key: 3, text: "Resumido Empleado", value: "Resumido empleado" },
	{ key: 4, text: "Resumido Sucursal", value: "Resumido sucursal" },
	{ key: 5, text: "Resumido Mes", value: "Resumido mes" },
	{ key: 6, text: "Resumido Gráfico", value: "Resumido grafico" },
];

export default typeOptions;
export const contactOption = [
	{
		label: "ID",
		key: "id",
		format: "string",
		dataPosition: "center",
		width: 1,
	},
	{
		label: "Plataforma",
		key: "contact.channel",
		format: "string",
		dataPosition: "center",
		width: 1,
		canFilter: true,
		canSort: true,
		canPrint: true,
		canExcel: true,
		sortKey: null,
	},
	{
		label: "Nombre",
		key: "name",
		format: "string",
		width: 1,
		canFilter: true,
		canSort: true,
		canPrint: true,
		canExcel: true,
		sortKey: null,
	},
	{
		label: "Teléfono",
		key: "phone",
		format: "phone",
		dataPosition: "center",
		width: 1,
		canFilter: true,
		canSort: true,
		canPrint: true,
		canExcel: true,
		sortKey: null,
	},
	{
		label: "Correo",
		key: "email",
		format: "string",
		headerPosition: "left",
		dataPosition: "left",
		width: 16,
		canFilter: true,
		canSort: true,
		canPrint: true,
		canExcel: true,
		sortKey: null,
	},
];

export const contactFilterOption = [
	{ key: "name", text: "Nombre", value: "name" },
	{ key: "code", text: "Código", value: "code" },
	{ key: "phone", text: "Teléfono", value: "phone" },
	{ key: "email", text: "Email", value: "email" },
	{ key: "cedula", text: "Cédula", value: "cedula" },
	{ key: "city", text: "Ciudad", value: "city" },
	{ key: "zone", text: "Zona", value: "zone" },
	{ key: "sector", text: "Sector", value: "sector" },
];

export const dropdownOptions = [
	{
		key: "tabs",
		options: [
			{ key: "new", text: "Nuevo", value: "new" },
			{ key: "atender", text: "Atender", value: "atender" },
			{ key: "client", text: "Contacto", value: "client" },
		],
	},
	{
		key: "dateField",
		options: [
			{ key: "createdDate", text: "Fecha Inicio", value: "createdDate" },
			{ key: "closeDate", text: "Fecha Cierre", value: "closeDate" },
		],
	},
	{
		key: "stateValue",
		options: [
			{ key: "a_tiempo", text: "A Tiempo", value: "A Tiempo" },
			{ key: "en_atraso", text: "En Atraso", value: "En Atraso" },
			{ key: "vencido", text: "Vencido", value: "Vencido" },
		],
	},
	{
		key: "orderBy",
		options: [
			{ key: "createdDate", text: "Fecha de Creación", value: "createdDate" },
			{ key: "closeDate", text: "Fecha de Cierre", value: "closeDate" },
			{ key: "closeState", text: "Estado de Cierre", value: "closeState" },
			{ key: "channel.label", text: "Canal", value: "channel.label" },
			{ key: "contact.name", text: "Contacto", value: "contact.name" },
			{ key: "user.fullName", text: "Usuario", value: "user.fullName" },
			{ key: "tab", text: "Tabs", value: "tab" },
			{ key: "group.name", text: "Grupo", value: "group.name" },
			{ key: "tags.name", text: "Etiquetas", value: "tags.name" },
			// { key: "timestamp", text: "Timestamp", value: "timestamp" },
			{ key: "id", text: "ID", value: "id" },
		],
	},
	{
		key: "orderDirection",
		options: [
			{ key: "asc", text: "Ascendente", value: "asc" },
			{ key: "desc", text: "Descendente", value: "desc" },
		],
	},
];

export const orderByOptionsDetailed = [
	{ key: "closeDate", text: "Fecha Cierre", value: "closeDate" },
	{ key: "group.name", text: "Grupos", value: "group.name" },
	{ key: "user.fullName", text: "Usuario Cierre", value: "user.fullName" },
	{ key: "tags.name", text: "Etiquetas", value: "tags.name" },
	{ key: "contact.name", text: "Contacto", value: "contact.name" },
	{ key: "user.phone", text: "Teléfono", value: "user.phone" },
	{ key: "createdDate", text: "Tiempo Total", value: "createdDate" },
	{ key: "channel.label", text: "Canal", value: "channel.label" },
	{
		key: "closeTab",
		text: "Tab",
		value: "closeTab",
	},
];

export const orderByOptions = [
	{
		key: "orderDirection",
		options: [
			{ key: "asc", text: "Ascendente", value: "asc" },
			{ key: "desc", text: "Descendente", value: "desc" },
		],
	},
];

export const orderByOptionsResumidas = [
	{ key: "usuario", text: "Usuario", value: "user.fullName" },
	{ key: "grupo", text: "Grupo", value: "group.name" },
	{ key: "total", text: "Cerradas", value: "total" },
	{ key: "newCount", text: "Tab Nuevo", value: "newCount" },
	{ key: "agentCount", text: "Tab Atender", value: "agentCount" },
	{ key: "clientCount", text: "Tab Cliente", value: "clientCount" },
	{ key: "onTimeCount", text: "A Tiempo", value: "onTimeCount" },
	{ key: "delayedCount", text: "En Atraso", value: "delayedCount" },
	{ key: "expiredCount", text: "Vencido", value: "expiredCount" },
];

export const orderByOptionsHoraUsuarios = [
	{ key: "closeDate", text: "Fecha", value: "closeDate" },
	{ key: "user.fullName", text: "Usuarios", value: "user.fullName" },
	{ key: "total", text: "Total", value: "total" },
];

export const orderByOptionsHoraGrupos = [
	{ key: "closeDate", text: "Fecha", value: "closeDate" },
	{ key: "group.name", text: "Grupos", value: "group.name" },
	{ key: "total", text: "Total", value: "total" },
];
